var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Text } from 'grommet/es6/components/Text';
import { Keyboard } from 'grommet/es6/components/Keyboard';
import { FormClose } from 'grommet-icons/es6/icons/FormClose';
import { withFocus } from 'grommet/es6/components/hocs';
import { withTheme } from 'grommet/es6/components/hocs';

import { StyledTag, StyledIcon } from './StyledTag';

var Tag = function (_Component) {
  _inherits(Tag, _Component);

  function Tag() {
    var _temp, _this, _ret;

    _classCallCheck(this, Tag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.clickTag = function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled;

      if (!disabled && onClick) {
        onClick(e);
      }
      e.preventDefault();
      e.stopPropagation();
    }, _this.toggleTag = function (e) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          disabled = _this$props2.disabled;

      if (!disabled && onChange) {
        e.preventDefault();
        e.stopPropagation();
        onChange(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Tag.prototype.render = function render() {
    var _props = this.props,
        disabled = _props.disabled,
        label = _props.label,
        a11yTitle = _props.a11yTitle,
        reverse = _props.reverse,
        background = _props.background,
        onClick = _props.onClick,
        onChange = _props.onChange,
        theme = _props.theme,
        icon = _props.icon,
        color = _props.color,
        focusable = _props.focusable,
        round = _props.round,
        size = _props.size,
        truncate = _props.truncate,
        focus = _props.focus,
        rest = _objectWithoutProperties(_props, ['disabled', 'label', 'a11yTitle', 'reverse', 'background', 'onClick', 'onChange', 'theme', 'icon', 'color', 'focusable', 'round', 'size', 'truncate', 'focus']);

    var grommet = this.context.grommet;

    var tagRound = round || (theme.tag && theme.tag.border ? theme.tag.border.round : undefined);
    var canFocus = focusable && !disabled && !!(onClick || onChange);
    var closeIcon = void 0;
    if (icon || onChange) {
      closeIcon = React.createElement(
        StyledIcon,
        { theme: theme, disabled: disabled, onClick: onChange },
        icon || React.createElement(FormClose, null)
      );
    }
    return React.createElement(
      Keyboard,
      {
        onEnter: this.clickTag,
        onSpace: this.toggleTag
      },
      React.createElement(
        StyledTag,
        _extends({
          direction: 'row',
          justify: 'between',
          align: 'center',
          a11yTitle: a11yTitle,
          round: tagRound,
          onClick: onClick && this.clickTag,
          role: 'checkbox',
          'aria-checked': true,
          focus: focus,
          tabIndex: canFocus ? '0' : undefined,
          background: background,
          disabled: disabled,
          reverse: reverse,
          theme: theme,
          grommet: grommet
        }, rest),
        reverse && closeIcon,
        React.isValidElement(label) ? label : React.createElement(
          Text,
          {
            color: color,
            size: size,
            truncate: truncate
          },
          label && label.toString()
        ),
        !reverse && closeIcon
      )
    );
  };

  return Tag;
}(Component);

Tag.contextTypes = {
  grommet: PropTypes.object
};
Tag.defaultProps = {
  label: 'Text',
  pad: { horizontal: 'xsmall' },
  focusable: true
};


var TagDoc = void 0;
if (process.env.NODE_ENV !== 'production') {
  TagDoc = require('./doc').default(Tag); // eslint-disable-line global-require
}

var TagWrapper = compose(withTheme, withFocus)(TagDoc || Tag);

export { TagWrapper as Tag };


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/Tag/Tag.js
// module id = 1207
// module chunks = 0